export const DEP_ONLINE_FORM = 'depOnline';
export const EMPTY_VALUE = '';

export const DEP_ONLINE_FORM_INITIAL_VALUES = {
  depAccountTypeOption: 'active',
  searchOption: 'bill',
  hob: 'NY065001000',
};
